module.exports = __webpack_public_path__ + "img/oie-global-background_ijefk8_c_scale_w_500.jpg";